export default __webpack_public_path__ + "static/logos-providers-a6e9e46e039055e21fec322285a37458.png";